const initState = {
  loading: false,
  data: null,
  error: "",
};

export const LoyaltyUserReducer = (state = initState, actions) => {
  switch (actions.type) {
    case "LOADING_LOYALTY_USER":
      return {
        ...state,
        loading: true,
      };

    case "LOYALTY_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        data: actions.data,
        error: "",
      };

    case "LOYALTY_USER_ERROR":
      return {
        ...state,
        loading: false,
        data: null,
        error: actions.error,
      };

    default:
      return state;
  }
};
